import React from 'react';
import { SOURCE_COLORS } from '../types/playbook.types';
import type { PlaybookSource } from '../types/playbook.types';

interface SourceBadgeProps {
  source: PlaybookSource;
}

const LABELS: Record<PlaybookSource, string> = {
  manual: 'Manual',
  ai_generated: 'AI Generated',
  court_rules: 'Court Rules',
  imported: 'Imported',
};

const SourceBadge: React.FC<SourceBadgeProps> = ({ source }) => {
  const colors = SOURCE_COLORS[source] || SOURCE_COLORS.manual;
  return (
    <span
      className={`inline-flex items-center rounded-full px-2 py-0.5 text-[10px] font-medium ${colors.bg} ${colors.text} ${colors.darkBg} ${colors.darkText}`}
    >
      {LABELS[source] || source}
    </span>
  );
};

export default SourceBadge;
